module.exports = new __parcel__URL__("last.fm.f914f671.png").toString();